@if (!isMandateProfile){
<div class="dashboard-container">
    @for(section of dashboardCards?.Sections; track $index)
    {
    <div class="row" id="{{'section_' + section.ID}}">
        @for(column of section.PortletColumns; track $index){ 
        @if(column.Show){
           
        <div class="{{column.ColumnSizeClass}} mt-4">
            @for (portlet of getPortletsBySectionAndColumn(section, column); track $index) {
                @defer (on viewport) {
                    <div [appWidgetLoader]="portlet.TargetAction"></div>
                } @placeholder {
                    <app-loader></app-loader>
                }
               }
            </div>
            }
        }

    </div>
    }
</div>
}